/* ------------ -------------- ------------*/
/* ------------  Validate Form ------------*/
/* ------------ -------------- ------------*/

export default  (values) =>{

    const errors = {}
    // if (!values.username) {
    //     errors.username = 'Required'
    // } else if (values.username.length > 15) {
    //     errors.username = 'Must be 15 characters or less'
    // }
    //if (!values.email) {
        //     errors.email = 'این فیلد ضروری است'
        // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        //     errors.email = 'ادرس ایمیل نا معتبر است'
        // }
    if (!values.name) {
        errors.name = 'این فیلد ضروری است'
    }
    if (!values.family) {
        errors.family = 'این فیلد ضروری است'
    }
    if (!values.username) {
        errors.username = 'این فیلد ضروری است'
    }
    if (values.password < 6) {
        errors.password = 'رمز عبور میبایست شامل حداقل 6 کاراکتر باشد'
    }
    if (!values.mobile) {
        errors.mobile = 'این فیلد ضروری است'
    }
    if (!values.phone) {
        errors.phone = 'این فیلد ضروری است'
    }
    if (values.role < 0 ||  typeof  values.role == 'undefined') {
        errors.role = 'این فیلد ضروری است'
    }
    if (values.state < 0 ||  typeof  values.state == 'undefined') {
        errors.state = 'این فیلد ضروری است'
    }
    if (values.city < 0 ||  typeof  values.city == 'undefined') {
        errors.city = 'این فیلد ضروری است'
    }
    if (values.branch_operator_state < 0 ||  typeof  values.branch_operator_state == 'undefined') {
        errors.branch_operator_state = 'این فیلد ضروری است'
    }
    if (values.branch_operator_cities < 0 ||  typeof  values.branch_operator_cities == 'undefined') {
        errors.branch_operator_cities = 'این فیلد ضروری است'
    }

    return errors
};